<template>
  <div class="coupon-use">
    <pageHeader title="选择优惠券" />

    <div class="coupon-nouse">
      <!-- <van-loading size="24px" v-if="isLoading" vertical>加载中...</van-loading> -->
      <div
        class="coupon-item"
        :code="item.classify"
        v-for="item in couponList"
        :key="item.id"
      >
        <div class="coupon-info">
          <div class="coupon-amount">
            <div class="coupon-amount-info">
              <span>¥</span>
              <span>{{ item.amount.slice(1) }}</span>
            </div>
            <div class="use-desc">
              <h1>{{ item.enableAmount }}</h1>
              <span class="tag">{{ item.classify | couponClassifyMaps }}</span>
            </div>
          </div>
        </div>
        <div class="coupon-time" :code="item.classify">
          {{ item.expiresTime }}
        </div>

        <div class="type-use" @click="choseCoupon(item)">
          <img
            v-if="item.selected"
            src="@/assets/images/ic_filter_2.png"
            alt=""
          />
          <img v-else src="@/assets/images/ic_filter_2_normal.png" alt="" />
        </div>
      </div>
    </div>

    <div class="coupon-use-btn">
      <span
        >已选择{{ selectNum }}张，可抵用<em>{{ amount }}</em></span
      >
      <div
        @click="confirmCoupon"
        :class="['confirm-use', selectNum != 0 ? 'confirm-use-actived' : '']"
      >
        确认使用
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { requestMethods } from "@m/api";
import pageHeader from "@/components/PageHeader";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      couponList: [],
      currentIndex: "",
      isLoading: false,
      amount: "￥0",
      selectNum: 0,
      userCouponId: ''
    };
  },
  computed: {
    ...mapGetters(["userInfo", "uuid"]),
  },
  filters: {
    couponTypeMaps(val) {
      if (val == "COMMON") {
        return "通用券";
      }
      if (val == "UNIVERSAL") {
        return "万能券";
      }
      if (val == "CONTINUE_CHARGE") {
        return "续充券";
      }
      if (val == "FIRST_CHARGE") {
        return "首充券";
      }
    },
    couponClassifyMaps(val) {
      if (val == "COMMON") {
        return "全类别通用";
      }
      if (val == "UNIVERSAL") {
        return "全平台可用";
      }
      if (val == "CONTINUE_CHARGE") {
        return "仅限续充使用";
      }
      if (val == "FIRST_CHARGE") {
        return "仅限首充使用";
      }
    },
  },
  mounted() {
    this.couponListQr();
  },
  methods: {
    async couponListQr() {
      this.isLoading = true;
      const { amount, gameId, gameAccountNo } = this.$route.query;
      try {
        const { data } = await requestMethods(
          "/modules/coupon/userCoupon/useCouponList.htm",
          "post",
          {
            uuid: this.uuid,
            amount,
            gameId,
            gameAccountNo,
          }
        );
        this.couponList =
          data.map((e) => {
            return {
              ...e,
              selected: false,
            };
          }) || [];
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },
    choseCoupon(info) {
      this.couponList
        .filter((e) => e.id != info.id)
        .forEach((k) => (k.selected = false));

      info.selected = !info.selected;
      if (info.selected) {
        this.selectNum = 1;
        this.amount = info.amount;
        this.userCouponId = info.id
      } else {
        this.amount = "￥0";
        this.selectNum = 0;
      }
    },

    /**
     * 选择优惠券后回显
     */
    confirmCoupon() {
      if (this.selectNum == 1) {
        this.$router.replace({
          path: "/recharge",
          query:{
            ...this.$route.query,
            chosenCoupon: this.amount,
            userCouponId: this.userCouponId,
            pageFrom: 'coupon'
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-use {
  width: 750px;
}
.coupon-nouse {
  padding: 20px;
  .coupon-item {
    width: 710px;
    height: 200px;
    padding: 32px 32px 30px 32px;
    margin-bottom: 20px;
    position: relative;

    &[code="COMMON"] {
      background: url("~@/assets/images/bg_coupon_one.png");
      background-size: 100% 100%;
    }
    &[code="FIRST_CHARGE"] {
      background: url("~@/assets/images/bg_coupon_two.png");
      background-size: 100% 100%;
    }
    &[code="CONTINUE_CHARGE"] {
      background: url("~@/assets/images/bg_coupon_three.png");
      background-size: 100% 100%;
    }
    &[code="UNIVERSAL"] {
      background: url("~@/assets/images/bg_coupon_four.png");
      background-size: 100% 100%;
    }

    .coupon-info {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .coupon-amount {
        display: flex;
        align-items: flex-start;

        .coupon-amount-info {
          display: flex;
          align-items: flex-start;
          margin-right: 40px;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 50px;
            color: #ffffff;
            line-height: 50px;

            &:last-child {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 110px;
              color: #ffffff;
              line-height: 90px;
            }
          }
        }
        .use-desc {
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 40px;
            color: #ffffff;
            line-height: 56px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #ffffff;
            line-height: 33px;
            display: block;
            opacity: 0.5;
          }
        }
      }

      .type-name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #ffffff;
        margin-bottom: 28px;
      }
      .use-btn {
        width: 170px;
        height: 60px;
        border-radius: 30px;
        border: 2px solid #ffffff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 30px;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
      }
    }
    .coupon-time {
      width: 307px;
      height: 31px;
      background: url("~@/assets/images/time-bg.png");
      background-size: 100% 100%;
      line-height: 31px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 22px;
      color: #ff7a3e;
      margin-left: -32px;
      padding-left: 31px;
      margin-top: 20px;

      &[code="COMMON"] {
        color: #ff7a3e;
      }
      &[code="FIRST_CHARGE"] {
        color: #0091ff;
      }
      &[code="CONTINUE_CHARGE"] {
        color: #9368ff;
      }
      &[code="UNIVERSAL"] {
        color: #f1928a;
      }
    }

    .type-use {
      position: absolute;
      right: 90px;
      top: 70px;
    }
  }
}

.coupon-use-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  margin-bottom: 8px;
  padding: 0 20px;
  width: 100%;

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #e6e6e6;

    em {
      color: #ff7a3e;
    }
  }
  .confirm-use {
    width: 180px;
    height: 66px;
    border-radius: 8px;
    color: #fff;
    text-align: center;
    line-height: 66px;
    background: #e6e6e6;
    font-size: 28px;

    &.confirm-use-actived {
      background: #ff7a3e;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/couponUse/index.vue